import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from 'primereact/progressspinner';
import { instance } from "../../api";
import Pagination from "./Pagination";
import "./Pagination.css"
export default function Connexions() {
    const [gexConnections, setGexConnections] = useState();
 
    const [globalFilter, setGlobalFilter] = useState(null);
    const [filteredConnections, setFilteredConnections] = useState([]); 
    const [searchText, setSearchText] = useState(""); 
    const [currentPage, setCurrentPage] = useState(1);
    //const dataPerPage = 10;
    const [dataPerPage, setDataPerPage] = useState(100);
    const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
    };
    
    const totalPages = Math.ceil((filteredConnections?.length || 0) / dataPerPage);
    const lastIndex = currentPage * dataPerPage;
    const firstIndex = lastIndex - dataPerPage;
    const currentData = filteredConnections?.slice(firstIndex, lastIndex) || [];
  
    const dt = useRef(null);
    useEffect(() => {
      instance
        .get(`/api/utilisateurs/connections`)
        .then((result) => {
            setGexConnections(result.data);
            setFilteredConnections(result.data); // Initialiser la liste filtrée
        
        }).catch((error) =>
          console.error("Erreur lors du chargement des connexions :", error));
    }, []);
    // Gestion de la recherche dynamique
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value); // Mettre à jour le texte de recherche

    if (value.trim() === "") {
      setFilteredConnections(gexConnections); // Si vide, afficher toutes les connexions
    } else {
      const filtered = gexConnections.filter((connection) =>
        connection.email.toLowerCase().includes(value.toLowerCase()) ||
        connection.id_utilisateur_gexonline.toString().includes(value) ||
        connection.login_date.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredConnections(filtered); // Mettre à jour avec les résultats filtrés
    }
  };
    const header = (
        <div className="table-header">
          <h5 className="mx-0 my-1">Liste des connexions des utilisateurs</h5>
          <span className="p-input-icon-right">
            <InputText
              type="search"
              value={searchText} // Maintenir le texte de recherche
              onChange={handleSearchChange} // Recherche à chaque changement
              placeholder=" Chercher..."
            />
            <i className="pi pi-search" />
          </span>
        
        </div>
      );
    return (
        <div className="datatable-crud">
{ gexConnections &&
      <DataTable
        ref={dt}
        value={filteredConnections}
        dataKey="id"
        emptyMessage={ <ProgressSpinner />} 
        globalFilter={globalFilter}
        header={header}  
        className="crudTable"
        scrollable  scrollHeight="450px" 
      >
        <Column
          field="id_utilisateur_gexonline"
          header="Id Gexonline"
          style={{ minWidth: "3rem" }}
          body={(rowData) => (
            <div className="table-data">
              <span className="mobile-header">Id Gexonline </span>
              {rowData.id_utilisateur_gexonline}
            </div>
          )}
        ></Column>
        <Column
          field="email"
          header="Email"
          style={{ minWidth: "3rem" }}
          body={(rowData) => (
            <div className="table-data">
              <span className="mobile-header">Email </span>
              {rowData.email}
            </div>
          )}
        ></Column>
        <Column
          field="login_date"
          header="Date de connexion"
          style={{ minWidth: "45rem" }}
          body={(rowData) => (
            <div className="table-data">
              <span className="mobile-header">Date de connexion </span>
              {rowData.login_date}
            </div>
          )}
        ></Column>

    
      </DataTable>
    }
    <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        dataPerPage={dataPerPage}
        setDataPerPage={setDataPerPage}
        handlePageChange={handlePageChange}
      />
    </div>
    )
}